// extracted by mini-css-extract-plugin
export var modal = "_5j-0";